const UseSetterNodeValue = (currentNode, tabName, fieldName, value) => {

    currentNode.data.form ??= {};
    currentNode.data.form.tabs ??= {};
    currentNode.data.form.tabs[tabName] ??= {};
    currentNode.data.form.tabs[tabName].fields ??= {};
    currentNode.data.form.tabs[tabName].fields[fieldName] ??= {};

    value?.entity && delete value.entity;

    currentNode.data.form.tabs[tabName].fields[fieldName] = {
        error: null,
        value: value
    };

    return currentNode
}

export default UseSetterNodeValue

